import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0B0B1A",
                        border: "1px solid rgba(0, 240, 255, 0.35)",
                        color: "#fff",
                        fontFamily: "JetBrains Mono, monospace",
                    },
                }}
            />
        </div>
    );
}

export default App;
